import Button from '@mui/material/Button'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { memo, useCallback, useMemo } from 'react'

import { isInstantWireMode } from '@/constants/index'
import { IconName, staticImportIcon } from '@/utils/static-import-icon'

const BackButton = ({ href }: { href?: string }) => {
  const router = useRouter()

  const handleBackOnClick = useCallback(() => {
    if (!href) {
      router.back()
    } else {
      router.push(href, undefined, { shallow: false })
    }

  }, [router, href])

  const backIcon = useMemo(() => {
    return staticImportIcon(isInstantWireMode() ? IconName.BACK_GRAY : IconName.BACK)
  }, [])

  return (
    <Button
      data-testid="btn-back"
      className="w-fit min-w-fit p-2 bg-[#1E2735] iw:bg-[#EAEAEA] iw:hover:bg-[#DFF1FF] rounded-full"
      onClick={handleBackOnClick}>
      <Image src={backIcon} alt="back" className="w-4 sm:w-6" />
    </Button>
  )
}

export default memo(BackButton)
